var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"top":"","right":"","color":_vm.snackBarNotification.color},model:{value:(_vm.isActive),callback:function ($$v) {_vm.isActive=$$v},expression:"isActive"}},[_c('span',[_vm._v(_vm._s(_vm.snackBarNotification.msg))])])}
var staticRenderFns = []

export { render, staticRenderFns }